import styled from 'styled-components';
import { number } from 'prop-types';
import { C_CHALK } from '@bbc/psammead-styles/colours';
import { BBC_BLOCKS } from '@bbc/psammead-assets/svgs';
var ImagePlaceholder = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImagePlaceholder",
  componentId: "sc-11u25v2-0"
})(["position:relative;height:0;overflow:hidden;background-color:", ";background-position:center center;background-repeat:no-repeat;background-size:30%;padding-bottom:", "%;width:100%;background-image:url(data:image/svg+xml;base64,", ");"], C_CHALK, function (props) {
  return props.ratio;
}, BBC_BLOCKS);
ImagePlaceholder.propTypes = {
  ratio: number.isRequired
};
export default ImagePlaceholder;